import React from "react";
import QuizOption from "./QuizOption";

export default function QuizOptions({
  handleOptionSelected,
  options,
  quizId,
  question,
}) {
  return (
    <form className="quizOptions">
      {options?.map((option) => (
        <QuizOption
          key={option.id}
          handleOptionSelected={handleOptionSelected}
          question={question}
          optionId={option.id}
          option={option}
          quizId={quizId}
        />
      ))}
    </form>
  );
}
